"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSizeSelector = void 0;
const React = __importStar(require("react"));
const Spacer_1 = __importDefault(require("../Spacer/Spacer"));
const PageSizeSelector = (props) => {
    return (React.createElement("div", { className: props.sideText ? 'page-size-selector-with-show-text' : '' },
        props.sideText && React.createElement("p", { className: "side-text" }, props.sideText),
        props.sideText && React.createElement(Spacer_1.default, { size: "sm" }),
        React.createElement("select", { onChange: (event) => props.onChange(event), className: "page-size-selector", value: props.selectedOption }, props.rowCountOptions.map((option) => (React.createElement("option", { value: option.value, key: option.label, className: "row-count-select-dropdown" }, option.label))))));
};
exports.PageSizeSelector = PageSizeSelector;
//# sourceMappingURL=PageSizeSelector.js.map